import WooCommerceSignupForm from "features/signup/woocommerce/WooCommerceSignupForm";
import WooCommerceSignupLayout from "features/signup/woocommerce/WooCommerceSignupLayout";
import { useCheckLoginStatus } from "Hooks";
import { useEffect, useState } from "react";

const HIT_STAGE_KEY = "AaXD8cw";

function WooCommerceSignup() {
  useCheckLoginStatus();
  const [hitRegistered, setHitRegistered] = useState(false);

  useEffect(() => {
    if (hitRegistered) {
      return;
    }

    (window as any).inc("append_lead_status", HIT_STAGE_KEY, true);
    setHitRegistered(true);
  }, [hitRegistered]);

  return (
    <WooCommerceSignupLayout>
      <WooCommerceSignupForm />
    </WooCommerceSignupLayout>
  );
}

export default WooCommerceSignup;
